import { useRecordContext, useT } from '@powerportalspro/react';
import { useEffect, useRef } from 'react';

// The example document the Blazor RichEdit demo page opens on, from the same localized string.
const SAMPLE_DOCUMENT =
  'components.PowerPortalsPro.Demo.Client.Customizations.Pages.Editors.RichEdit.RichEditDemoPage.sample-document';

/**
 * Puts an example document into a column of the sample's new record, once: the RichEdit demo
 * page's, or the one `documentKey` names.
 */
export function useExampleDocument(columnName: string, documentKey: string = SAMPLE_DOCUMENT): void {
  const { record, setColumnValue } = useRecordContext();
  const t = useT();
  const seeded = useRef(false);
  useEffect(() => {
    if (seeded.current || !record) return;
    seeded.current = true;
    setColumnValue(columnName, { $type: 14, value: t(documentKey) });
  }, [columnName, documentKey, record, setColumnValue, t]);
}
